<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-10 col-lg-8 col-xl-6 mt-5">
        <div class="card overflow-hidden" v-if="step === 1">
          <div class="bg-soft-white">
            <div class="row">
              <div class="col-12">
                <div class="text-normal p-4">
                  <h5 class="text-normal">Confirmação de presença</h5>
                  <p>Falta pouco para confirmar a sua presença no evento <strong>{{ eventName }}</strong></p>
                </div>
              </div>
              <!-- <div class="col-4 align-self-end">
                <img
                  src="@/assets/images/profile-img.png"
                  alt
                  class="img-fluid"
                />
              </div> -->
            </div>
          </div>
          <div class="card-body pt-0">
            <b-alert
              v-model="isAuthError"
              variant="danger"
              class="mt-3"
              dismissible
              >{{ authError }}</b-alert
            >

            <b-form class="p-2" @submit.prevent="validEmail">
              <b-form-group
                id="input-group-1"
                label="Informe o seu e-mail"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="form.email"
                  type="text"
                  placeholder="Informe o seu e-mail"
                  :class="{ 'is-invalid': submitted && $v.form.email.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.form.email.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.email.required">E-mail é obrigatório.</span>
                  <span v-if="!$v.form.email.email">Por favor, informe e-mail válido.</span>
                </div>
              </b-form-group>
              <div class="mt-4">
                <b-button type="submit" variant="primary" class="btn-block"
                  >PROSSEGUIR</b-button
                >
              </div>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <div class="card overflow-hidden" v-if="step === 2">
          <div class="bg-soft-white">
            <div class="row">
              <div class="col-12">
                <div class="text-normal p-4">
                  <h5 class="text-normal">Olá, {{ participant.name }}</h5>
                  <p>Deseja confirmar a sua presença no evento <strong>{{ eventName }}</strong> ?</p>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="p-2">
              <div class="mt-4">
                <b-button type="button" :disabled="clicked" @click.prevent="updateProfile('confirmed')" variant="success" class="btn-block"
                  >CONFIRMAR PRESENÇA</b-button
                >
              </div>
              <div class="mt-4">
                <b-button type="button" :disabled="clicked" @click="updateProfile('declined')" variant="danger" class="btn-block"
                  >DECLINAR</b-button
                >
              </div>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>
            © {{ new Date().getFullYear() }} RSVPFY. Feito com
            <i class="mdi mdi-heart text-danger"></i> por Eventfy
          </p>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
<script>
import Layout from '@/components/layout/auth'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import appConfig from '@/app.config'
import { required, email } from 'vuelidate/lib/validators'
import service from '../services'

export default {
  page: {
    title: 'Confirmação de presença',
    meta: [
      {
        name: 'description',
        content: appConfig.description
      }
    ]
  },
  components: {
    Layout
  },
  data () {
    return {
      participant: null,
      submitted: false,
      clicked: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      step: 1,
      form: {
        email: ''
      }
    }
  },
  validations: {
    form: {
      email: {
        required,
        email
      }
    }
  },
  methods: {
    async updateProfile (action) {
      try {
        this.clicked = true
        if (!this.participant.id) {
          this.step = 1
          return
        }
        await service.updateRegister({ participantId: this.participant.id, action }).then((data) => {
          this.participant = data.data
          let message = action === 'confirmed' ? 'Sucesso: Confirmação realizada com sucesso' : 'Sucesso: Presença declinada do evento.'
          let delay = 3000
          successMessage(message, delay).then(() => {
            this.loading = false
            this.step = 1
            this.participant = null
            this.form.email = ''
            this.clicked = false
            this.$v.$reset()
            // mostra opção de confirmar/declinar
          })
        })
      } catch (err) {
        console.log(err)
        this.clicked = false
        errorMessage('Alerta: Ocorreu um erro ao registrar ação.')
      }
    },
    async validEmail () {
      try {
        this.submitted = true
        this.$v.form.$touch()

        if (this.$v.form.$invalid) {
          return
        }
        await service.checkEmail(this.form).then((data) => {
          this.participant = data.data
          let message = 'Sucesso: E-mail validado com sucesso...'
          let delay = 2000
          successMessage(message, delay).then(() => {
            this.loading = false
            this.step = 2
            // mostra opção de confirmar/declinar
          })
        })
      } catch (err) {
        console.log(err)
        errorMessage(err ? err.message : 'Alerta: E-mail não encontrado na base de convidados.')
      }
    }
  },
  computed: {
    eventName () {
      return process.env.VUE_APP_EVENTNAME
    }
  }
}
</script>

<style scoped lang="scss">
.login-page {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .card {
    width: 30%;
  }
}
</style>
